import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import ShortTextIcon from "@mui/icons-material/ShortText";
import MenuIcon from "@mui/icons-material/Menu";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import StarHalfOutlinedIcon from "@mui/icons-material/StarHalfOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import QueryBuilderOutlinedIcon from "@mui/icons-material/QueryBuilderOutlined";
import CloseIcon from "@mui/icons-material/Close";

const question_type_list = [
  { value: "textfield", label: "Short Answer", icon: <ShortTextIcon /> },
  { value: "textarea", label: "Long Answer", icon: <MenuIcon /> },
  { value: "radio", label: "Single Choice", icon: <RadioButtonCheckedIcon /> },
  { value: "checkbox", label: "Multi Choice", icon: <CheckBoxOutlinedIcon /> },
  {
    value: "select",
    label: "Dropdown Menu",
    icon: <ArrowDropDownCircleOutlinedIcon />,
  },
  { value: "rating", label: "Rating", icon: <StarHalfOutlinedIcon /> },
  { value: "date", label: "Date", icon: <EventOutlinedIcon /> },
  { value: "time", label: "Time", icon: <QueryBuilderOutlinedIcon /> },
];

const StackPage = ({ open, onSave, onClose }) => {
  // ------------------------- Question  ------------------------------
  const [questionId, setQuestionId] = useState("" + new Date().getTime());
  const [question, setQuestion] = useState("");
  // ------------------------------------------------------------------

  // ------------------------- Required -------------------------------
  const [required, setRequired] = useState(false);
  const required_checkbox_on_change = (event) => {
    setRequired(event.target.checked);
  };
  // ------------------------------------------------------------------

  // ------------------------- Question Type --------------------------
  const [answerType, setAnswerType] = useState("");
  const questiontype_select_on_change = (e) => {
    setAllottedOption([]);
    setAnswerType(e.target.value);
    if (e.target.value === "radio") setShowOptions(true);
    else if (e.target.value === "checkbox") setShowOptions(true);
    else if (e.target.value === "select") setShowOptions(true);
    else setShowOptions(false);
  };
  // ------------------------------------------------------------------

  // ------------------------- Options ---------------------------------
  const [showOptions, setShowOptions] = useState(false);
  const [allottedOption, setAllottedOption] = useState([]);

  // const add_option = () => {
  //   setOptions([...options, { id: "" + new Date().getTime(), value: "" }]);
  // };
  const add_option = () => {
    const nextOptionChar = String.fromCharCode(97 + allottedOption.length);
    const newOption = {
      id: `option${nextOptionChar.toUpperCase()}`,
      value: "",
    };
    setAllottedOption([...allottedOption, newOption]);
  };


  const option_value_on_change = (id, value) => {
    const updatedOptions = allottedOption.map((option) =>
      option.id === id ? { ...option, value } : option
    );
    setAllottedOption(updatedOptions);
  };


  const remove_option = (id) => {
    const updatedOptions = allottedOption.filter((option) => option.id !== id);
    setAllottedOption(updatedOptions);
  };
  // -------------------------------------------------------------------

  const add_stack_to_form = () => {
    if (question.trim().length <= 0) alert("Add question");
    else if (answerType.trim().length <= 0) alert("Add question type");
    else {
      //setQuestionId("" + new Date().getTime());
      var stack_data = {
        questionId: "" + new Date().getTime(),
        question,
        required,
        answerType,
        allottedOption,
      };
      onSave(stack_data);
      reset();
    }
  };

  const cancel_button_on_click = () => {
    reset();
    onClose();
  };

  const reset = () => {
    //setQuestionId("");
    setQuestion("");
    setRequired(false);
    setAnswerType("");
    setShowOptions(false);
    setAllottedOption([]);
  };

  return (
    <Dialog
      open={open}
      onClose={cancel_button_on_click}
      fullWidth
      maxWidth="lg"
      aria-labelledby="add-form-element"
      aria-describedby="add-form-element"
    >
      <DialogTitle id="add-form-element">Add Form Element</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={7}>
            <FormControl
              variant="standard"
              sx={{ m: 1, minWidth: 120, width: "100%" }}
            >
              <TextField
                id="question"
                label="Add Question"
                variant="standard"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox />}
                label="Required"
                onChange={required_checkbox_on_change}
              />
            </FormGroup>
          </Grid>
          <Grid item xs={3}>
            <FormControl
              variant="standard"
              sx={{ m: 1, minWidth: 120, width: "100%" }}
            >
              <InputLabel id="question-type">Question Type</InputLabel>
              <Select
                label="Question Type"
                value={answerType}
                onChange={questiontype_select_on_change}
                labelId="question-type-label"
                id="question-type-labelid"
              >
                {question_type_list.map((question_type_list_item) => (
                  <MenuItem
                    key={question_type_list_item.value}
                    value={question_type_list_item.value}
                  >
                    {question_type_list_item.icon}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {question_type_list_item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Options Panel */}
        {showOptions && (
          <Grid container spacing={2}>
            <Grid item xs={8}>
              {allottedOption.map((option) => (
                <div key={option.id} style={{ padding: 10 }}>
                  <TextField
                    value={option.value}
                    onChange={(e) =>
                      option_value_on_change(option.id, e.target.value)
                    }
                    size="small"
                  />
                  <IconButton
                    aria-label="delete"
                    onClick={() => remove_option(option.id)}
                    color="error"
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              ))}
              <Button onClick={add_option}>Add Options</Button>
            </Grid>
            <Grid item xs={4}>
              {/* add some extra stuff here */}
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel_button_on_click}>Cancel</Button>
        <Button onClick={add_stack_to_form} autoFocus>
          Add Form Element
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StackPage;
